import {
  LayoutDashboard,
  ShieldCheck,
  Building2,
  Handshake,
  Users,
  LayoutGrid,
  BadgeCheck,
  LifeBuoy,
  Settings,
  CreditCard,
} from "lucide-react";

// `permission` is the admin-access module key required to see the link.
export const sidebarSections = [
  {
    title: "Overview",
    links: [{ name: "Dashboard", icon: LayoutDashboard, route: "/dashboard", permission: "dashboard" }],
  },
  {
    title: "Management",
    links: [
      { name: "Hospitals", icon: Building2, route: "/providers", permission: "providers" },
      { name: "Subscriptions", icon: CreditCard, route: "/subscriptions", permission: "subscriptions" },
      { name: "Payments", icon: CreditCard, route: "/payments", permission: "payment_config" },
      { name: "Patients", icon: Users, route: "/patients", permission: "patients" },
      { name: "Partners", icon: Handshake, route: "/patners", permission: "partners" },
    ],
  },
  {
    title: "Access control",
    links: [
      {
        name: "IAM",
        icon: ShieldCheck,
        subLink: [
          { name: "Admin users", route: "/iam/users", permission: "iam_admins" },
          { name: "Roles & permissions", route: "/iam/roles", permission: "iam_roles" },
          { name: "Hospital admins", route: "/iam/provider-users", permission: "providers" },
        ],
      },
    ],
  },
  {
    title: "Platform",
    links: [
      {
        name: "Apps",
        icon: LayoutGrid,
        subLink: [
          { name: "Website", route: "/apps/website", permission: "apps" },
          { name: "Patient", route: "/apps/patient", permission: "apps" },
          { name: "Practitioner", route: "/apps/practitioner", permission: "apps" },
          { name: "Studio", route: "/apps/studio", permission: "apps" },
          { name: "Admin", route: "/apps/admin", permission: "apps" },
          { name: "Accounts", route: "/apps/accounts", permission: "apps" },
        ],
      },
      { name: "Trust", icon: BadgeCheck, route: "/trust", permission: "trust" },
      { name: "Support", icon: LifeBuoy, route: "/support", permission: "support" },
    ],
  },
  {
    title: "Settings",
    links: [
      { name: "General", icon: Settings, route: "/general", permission: "general" },
    ],
  },
];
